<template>
    <div>
      
    <div class="vx-row">
      <div class="w-full mb-base ml-2">
        <vs-checkbox v-model="unicPrice">Preço único</vs-checkbox>            
      </div>
    </div>

    <div class="vx-row">
        <div class="ml-4 w-11/12 sm:w-11/12 md:w-3/12 lg:w-2/12 xl:w-2/12" v-show="unicPrice">
          <div class="" v-show="unicPrice">
            <label>Preço</label>
              <money 
                class="vs-inputx vs-input--input normal"
                style="border: 1px solid rgba(0, 0, 0, 0.2);"
                v-model="productValue" 
                v-bind="money">
              </money>
          </div>
        </div>

        <div class="vx-row w-full" v-if="!unicPrice">
            <transition-group class="w-full ml-8" name="list" v-if="productInfo.options.hasOwnProperty('size')">
              <div class="w-full border border-dashed border-grey-light rounded p-4 mb-6" v-for="(size, iSize) in productInfo.options.size.items" :key="iSize + 0" style="position: relative">
                <vs-button size="small" radius class="btn-remove-product-option" color="danger" type="gradient" icon-pack="feather" icon="icon-trash" @click="removeSize(iSize)"></vs-button>
                <div class="vx-row ">
                    <div class="vx-col w-4/12">
                        <label>Tamanho</label>
                          <vs-input name="productSize" class="w-full" placeholder="Tamanho" :value="size.size" @input="newVal => changeSize(newVal, iSize)" />
                        <span class="text-danger">{{ errors[0] }}</span>
                    </div>
                    
                    <div class="vx-col w-4/12">
                      <label>Unidade</label>
                        <v-select name="productUnit" :options="unit" :value="size.unit" @input="newVal => changeProductUnit(newVal, iSize)" icon-pack="feather" icon="icon-maximize-2"/>
                    </div>

                    <div class="vx-col w-4/12">
                      <label>Preço</label>
                        <money 
                          @input="val => changeSizePrice(val, iSize)"
                          class="vs-inputx vs-input--input normal"
                          style="border: 1px solid rgba(0, 0, 0, 0.2);"
                          :value="size.value"
                          v-bind="money">
                        </money>
                    
                        <span class="text-danger">{{ errors[0] }}</span>
                    </div>
                </div>
                <!-- <vs-button class="vx-col mt-6 w-full" color="danger" type="flat" icon-pack="feather" icon="icon-trash" @click="removeSize(iSize)"> Remover </vs-button> -->
              </div>
            </transition-group>
          <vs-button class="mt-6 w-full ml-8" color="primary" type="border" icon-pack="feather" icon="icon-plus-circle" @click="addMoreSizes()"> Adicionar mais tamanhos</vs-button>
        </div>

        <div class="w-3/12 bg-grid-color-secondary h-12"></div>
      </div>  
    </div>
</template>

<script>
    import { mapState, mapMutations } from 'vuex'
    import firebase from '@/firebase/firebase'
    import vSelect from 'vue-select'
    import _misc from '@/assets/utils/misc.js'

    const ref = firebase.firestore()

    export default {
        components : {
            vSelect
        },

        data () {
            return {
                money: {
                    decimal: ',',
                    thousands: '.',
                    prefix: 'R$ ',
                    precision: 2,
                    masked: false
                },
                unicPrice : true,
                unit : []
            }
        },

        watch : {
            unicPrice (checked) {
              this.$emit('unicPrice', checked)
            },
        },

        computed : {
            productValue : {
                get () {
                    return this.productInfo.value
                },
                set (value) {
                    this.setProductValue(value)
                }
            },

            ...mapState('product', ['productInfo'])
        },

        mounted () {
            this.getUnit()
            this.toggleWhetherUnicPrice()
            this.$emit('unicPrice', this.unicPrice)
        },

        methods : {
            toggleWhetherUnicPrice () {
              if(!this.productInfo.hasOwnProperty('options')) return
              if(!this.productInfo.options.hasOwnProperty('size')) return
              this.unicPrice = false
            },

            changeSize (desc, iSize) {
                this.setSizeDescription({desc : desc, i : iSize})
            },

            changeProductUnit (val, iSize) {
                this.setSizeUnit({val : val, i: iSize})
            },

            changeSizePrice (val, iSize) {
                this.setSizePrice({ val : val, i : iSize })
            },

            async getUnit () {
                let query = await ref.collection('unit').get()
                let unitObj = [];
                query.forEach(doc => {
                unitObj.push({
                    label: doc.data().description,
                    shortDesc : doc.data().shortDesc,
                    value: doc.id
                })
                })
                this.unit = unitObj;
            },

            async addMoreSizes() {
                let randKey  = _misc.generateId(21)

                let sizeObj = {
                    size: '',
                    unit: '',
                    value : 0
                }

                if(!this.productInfo.options.hasOwnProperty('size')) {
                let size = {
                    id : 'size',
                    description : 'Tamanho',
                    min: 1,
                    type: "single",
                    order: 0,
                    items : {
                        
                    }
                    }
                    // this.$set(this.productInfo.options, 'size', size)
                    this.setSizeObj(size)
                }
                // this.$set(this.productInfo.options.size.items, randKey, sizeObj)
                this.setSizeItemObj({randKey: randKey, obj : sizeObj})
            },

            removeSize(id) {
                // this.$delete(this.product.options.size.items, id);
                this.removeItemSize(id) //asd
            },

            ...mapMutations('product', ['setProductValue', 'setSizeDescription', 'setSizeObj', 'setSizeItemObj', 'removeItemSize', 'setSizeUnit', 'setSizePrice']),
        }
    }
</script>

<style scoped>
  .list-enter-active, .list-leave-active {
    transition: all 1s;
  }

  .list-enter, .list-leave-to {
    opacity: 0;
    transform: translateX(90px);
  }

  .btn-remove-product-option {
    position: absolute;

    top: -15px; 
    left: 97%;
  }
</style>  